import React from 'react';
import { useNavigate } from 'react-router-dom';

const ServiceCard = ({ icon: Icon, title, description, linkTo }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (linkTo) {
      navigate(linkTo);
    }
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer group relative p-8 border border-zinc-800 bg-zinc-900/30 hover:bg-zinc-800/50 transition-all duration-700"
    >
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-white/20 to-transparent scale-x-0 group-hover:scale-x-100 transition-transform duration-700"></div>
      <div className="mb-6 inline-block p-3 rounded-full bg-zinc-800/50 text-white group-hover:bg-white group-hover:text-black transition-colors duration-500">
        <Icon size={24} strokeWidth={1.5} />
      </div>
      <h3 className="text-xl font-medium text-white mb-3 tracking-wide uppercase">{title}</h3>
      <p className="text-zinc-400 font-light leading-relaxed">{description}</p>
    </div>
  );
};

export default ServiceCard;